import { useState } from "react"
import { Link } from "react-router-dom"
import { navbar, socials } from "../data/data"
import CreateAccountDark from "../utils/CreateAccountDark"
import FooterLogo from "./FooterLogo"

export default function Footer() {
  const [links] = useState(navbar)
  const [socialLinks] = useState(socials)

  return (
    <>
      <footer className="max-width py-5">
        <div className="pb-5 md:pb-10">
          <FooterLogo />
        </div>

        <article className="flex flex-col items-start py-5 border-t-2 border-gray-700 md:flex-row md:justify-between md:py-10 md:items-center">
          <nav>
            <ul className="flex justify-center flex-col md:flex-row md:items-center">
              {links.map(({ id, title, url }) => (
                <li key={id} className="mb-5 md:mb-0 md:mr-5">
                  <Link to={url}>{title}</Link>
                </li>
              ))}
            </ul>
          </nav>

          <ul className="flex md:items-center pt-5 md:pt-0">
            {socialLinks.map(({ id, icon, url }) => (
              <li key={id} className="mr-5 text-3xl lg:mr-10 lg:text-4xl">
                <a href={url} target="_blank" rel="noopenner noreferrer">
                  {icon}
                </a>
              </li>
            ))}
          </ul>

          <ul className="flex items-center pt-10 md:pt-0">
            <li>
              <button>Sign In</button>
            </li>
            <li className="ml-5">
              <CreateAccountDark />
            </li>
          </ul>
        </article>
      </footer>
    </>
  )
}
